export default "__VITE_ASSET__rh3QNegY__"